import React from "react"
import MyDateDayMonthYearFormField from "@common-components/fields/MyDateDayMonthYearFormField"
import MyInputFormField from "@common-components/fields/MyInputFormField"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM, CONST_PERSONNEL_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2 } from "@common-constants/*"

export const NdfGroupedBasicFields = ({ helpers, validationSchema, index }: any) => {
     const isKM = helpers.values.childs[index].categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM

     return (
          <>
               {/* 1. On choisit la catégorie en premier */}
               <MySelectFormField
                    formikProps={helpers}
                    validationSchema={validationSchema}
                    options={CONST_PERSONNEL_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2}
                    name={`childs[${index}].categorie`}
                    isSearchable={false}
                    placeholder={"Sélectionnez la catégorie..."}
                    label={"Catégorie"}
                    classNameLabel="col-lg-4"
                    classNameField="col-lg-8"
               />

               {/* 2. Le numéro de ticket et la date apparaissent selon la catégorie */}
               {helpers.values.childs[index].categorie && !isKM && (
                    <div className="">
                         <MyInputFormField
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              name={`childs[${index}].numeroTicket`}
                              placeholder={"Saisissez le numéro de la dépense"}
                              label={<div className="required">Numéro de la dépense</div>}
                              autoComplete={"off"}
                              inputMode={"numeric"}
                              classNameLabel="col-lg-4"
                              classNameField="col-lg-8"
                              classNameLayout="mb-4"
                         />

                         <MyDateDayMonthYearFormField
                              name={`childs[${index}].date`}
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              placeholder={"Date"}
                              label={<span className={"required"}>Date</span>}
                              classNameLabel={"col-lg-4"}
                              classNameField={"col-lg-8"}
                         />
                    </div>
               )}
          </>
     )
}
